import { useEffect, useRef, useState } from 'react';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import classes from './NewsletterModal.module.scss';
import { NewsletterForm } from './NewsletterForm';
import LogoBg from '../../assets/LogoWithoutBackground.png';

const DISMISSED_KEY = 'AB_NEWSLETTER_MODAL_DISMISSED';
const OPEN_DELAY_MS = 2500;

export const NewsletterModal = () => {
    const [isOpen, setIsOpen] = useState(false);
    const modalRef = useRef(null);

    useEffect(() => {
        if (sessionStorage.getItem(DISMISSED_KEY)) return;

        const timer = setTimeout(() => setIsOpen(true), OPEN_DELAY_MS);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const node = modalRef.current;
        if (!node) return;

        if (isOpen) {
            disableBodyScroll(node, { reserveScrollBarGap: true });
        } else {
            enableBodyScroll(node);
        }

        return () => clearAllBodyScrollLocks();
    }, [isOpen]);

    const close = () => {
        sessionStorage.setItem(DISMISSED_KEY, 'true');
        setIsOpen(false);
    };

    useEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') close();
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className={classes.Overlay} onClick={close} role="presentation">
            <div
                ref={modalRef}
                className={classes.Modal}
                role="dialog"
                aria-modal="true"
                aria-labelledby="newsletter-modal-title"
                onClick={(event) => event.stopPropagation()}
            >
                <button type="button" className={classes.CloseButton} onClick={close} aria-label="Close">
                    &times;
                </button>

                <img src={LogoBg} alt="Abayatique" className={classes.Logo} />

                <div id="newsletter-modal-title" className={classes.Title}>
                    Something beautiful is coming
                </div>
                <div className={classes.Body}>
                    Abayatique is opening soon — a marketplace of abaya designers and sellers,
                    with every order customisable to you. Join the list to know the moment we
                    go live, plus an exclusive offer for early subscribers.
                </div>

                <NewsletterForm compact onSubscribed={() => sessionStorage.setItem(DISMISSED_KEY, 'true')} />

                <button type="button" className={classes.DismissLink} onClick={close}>
                    No thanks, maybe later
                </button>
            </div>
        </div>
    );
};

export default NewsletterModal;
